import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { InstalledApplication } from '@era/locations-sdk';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InstalledApplicationsResolverActions = createActionGroup({
  source: 'Installed Applications Resolver',
  events: {
    'Installed applications requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InstalledApplicationsApiActions = createActionGroup({
  source: 'Installed Applications API',
  events: {
    'Installed Applications loaded': props<{ installedApplications: InstalledApplication[] }>(),
    'Installed Applications loaded error': props<{ error: ErrorModel }>(),
  },
});
